import type { JobInvoiceStatus } from '@jobos/shared';

/**
 * Statuses that count as "sent" for date-tracking purposes. A partially paid
 * job has already been sent an invoice (and is not yet fully paid), so it
 * belongs alongside `invoice_sent` and `paid` here.
 */
const SENT_ISH: JobInvoiceStatus[] = ['invoice_sent', 'partially_paid', 'paid'];

/**
 * Returns a confirmation message when transitioning the invoice status would
 * clear a populated date column, or null when no confirmation is needed.
 *
 * Date columns: `lastInvoicedDate` is shown for `invoice_sent`, `partially_paid`,
 * and `paid`. `invoicePaidDate` is shown only for `paid`. Reverting away from
 * those states clears the relevant column.
 */
export function confirmInvoiceTransition(
  from: JobInvoiceStatus,
  to: JobInvoiceStatus,
  lastInvoicedDate: string | null | undefined,
  invoicePaidDate: string | null | undefined,
): string | null {
  const wasSent = SENT_ISH.includes(from);
  const willBeSent = SENT_ISH.includes(to);
  const willClearSent = wasSent && !willBeSent && !!lastInvoicedDate;

  const willClearPaid = from === 'paid' && to !== 'paid' && !!invoicePaidDate;

  if (willClearSent && willClearPaid) {
    return 'This will clear the Sent date and the Paid date. Continue?';
  }
  if (willClearSent) return 'This will clear the Sent date. Continue?';
  if (willClearPaid) return 'This will clear the Paid date. Continue?';
  return null;
}
